import React, { FC } from "react";

import { IButtonProps } from "@/components/Button";
import { ModalButton } from "@/views/components/Modal";

import { ISuggestedDataDialogProps, SuggestedDataDialogModal } from "./SuggestedDataDialogModal";

interface ISuggestedDataDialogModalButtonProps extends Omit<IButtonProps, "ref"> {
  dialogProps: ISuggestedDataDialogProps;
}

export const SuggestedDataDialogModalButton: FC<ISuggestedDataDialogModalButtonProps> = ({
  dialogProps,
  ...buttonProps
}) => {
  return (
    <ModalButton openable={SuggestedDataDialogModal} openableProps={{ ...dialogProps, size: "md" }} {...buttonProps} />
  );
};
